import React, { useContext } from 'react'
import { Grid, Typography } from '@mui/material'
import Lottie from 'lottie-react'
import { FcGoogle } from 'react-icons/fc'
import { MdOutlineEmail } from 'react-icons/md'
import { BeachTenis, waveAnimated } from '../../../assets'
import { AuthContext } from '../../../contexts/AuthContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import ButtonLoading from '../ButtonLoading/ButtonLoading'
import { signInWithGooglePopup } from '../../../config/firebaseContfig'
import { Services, LocalStorage } from '../../../services/'
import RouterHook from '../../../contexts/RouterHook'
import CryptoJS from 'crypto-js'
import Alerts from '../Alerts'

// Função para lidar com o armazenamento de tokens
const storeTokens = (accessToken, refreshToken) => {
  const bytes = CryptoJS.AES.decrypt(accessToken, import.meta.env.VITE_CRYPTO_KEY)
  LocalStorage.set('user-token', bytes.toString(CryptoJS.enc.Utf8))

  const bytesRefresh = CryptoJS.AES.decrypt(refreshToken, import.meta.env.VITE_CRYPTO_KEY)
  LocalStorage.set('user-refreshToken', bytesRefresh.toString(CryptoJS.enc.Utf8))
}

// Função para redirecionar o usuário
const redirectUser = (usuario, serverRouter, actionsAuth) => {
  let query = ''
  if (usuario.cidade && usuario.estado) {
    query = `${
      usuario.estado.length === 2 ? usuario.estado : Services.ReturnSiglaEstado(usuario.estado)
    }-${Services.RemoveCaracteresEspeciais(usuario.cidade)}`
  } else {
    query = ':localizacao'
  }

  const url = LocalStorage.get('url-selecionada')
  actionsAuth.clearUiControls()

  if (url) {
    query = url.url.split('/').pop()
    LocalStorage.remove('url-selecionada')
    LocalStorage.set('back-action', true)
    serverRouter('centro-esportivo', query)
  } else {
    serverRouter('home', query.toLowerCase())
  }
}

export default function MobileAuth() {
  const serverRouter = RouterHook()
  const { actionsAuth, loadsAuth } = useContext(AuthContext)
  const { actionsUCtx } = useContext(UsuarioContext)

  // Executa depois de receber do backend
  async function RunScript(req) {
    actionsUCtx.handleUsuario(req.usuario)
    storeTokens(req.tokens.accessToken, req.tokens.refreshToken)
    redirectUser(req.usuario, serverRouter, actionsAuth)
  }

  // Login via popup
  async function handleGoogleLogin() {
    try {
      actionsAuth.handleLoading('login-google')
      const credential = await signInWithGooglePopup()
      const user = credential.user
      if (!user) throw new Error('Nenhum usuário retornado do Google.')

      const idToken = await user.getIdToken()
      const data = {
        user: {
          nome: user.displayName,
          email: user.email,
          telefone: user.phoneNumber,
        },
        idToken,
      }

      const req = await actionsAuth.LoginComProvider(data)
      if (req.usuario && req.tokens) {
        await RunScript(req)
      } else {
        throw new Error('Resposta inesperada do backend.')
      }
    } catch (error) {
      // console.error('Erro no Google Popup:', error)
      Alerts.swal('warning', 'Aviso', error.message || 'Erro no login com Google.')
    } finally {
      actionsAuth.handleLoading('off')
    }
  }

  return (
    <>
      {/* Cabeçalho animado */}
      <div style={{ position: 'relative', width: '100%', height: '40%', overflow: 'hidden' }}>
        <Lottie
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          animationData={waveAnimated}
          rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
        />
        <img src={BeachTenis} alt='Beach Tennis' style={stDesk.fixedImg} />
      </div>

      {/* Botões de login */}
      <div className='contain-padding-mp'>
        <Grid container rowSpacing={0} gap={0} sx={{ marginTop: '10px' }}>
          <Typography variant='h6' sx={stDesk.titlePage}>
            AGENDEI QUADRAS
          </Typography>
          <Typography variant='h6' sx={stDesk.subTitle}>
            Conectamos você com o esporte!
          </Typography>
        </Grid>

        <Grid container rowSpacing={2} sx={stDesk.containButtons} marginTop={2}>
          <Grid item xs={12}>
            <ButtonLoading
              fullWidth
              variant='contained'
              sx={stDesk.buttonLogin}
              startIcon={<MdOutlineEmail size={28} />}
              onClick={() => actionsAuth.authStep('verifEmail')}
            >
              <Typography sx={stDesk.buttonText}>Continuar com E-mail</Typography>
            </ButtonLoading>
          </Grid>

          <Grid item xs={12}>
            <ButtonLoading
              fullWidth
              variant='contained'
              color='secondary'
              sx={stDesk.buttonLogin}
              startIcon={<FcGoogle size={28} />}
              loading={loadsAuth === 'login-google'}
              onClick={handleGoogleLogin}
            >
              <Typography sx={stDesk.buttonText}>Continuar com Google</Typography>
            </ButtonLoading>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

const stDesk = {
  containButtons: {
    px: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
  },
  titlePage: {
    fontFamily: 'rez-regular',
    fontSize: '2.4rem',
    textAlign: 'center',
    color: 'var(--color-text-hig)',
    width: '100%',
  },
  subTitle: {
    fontFamily: 'jost-light',
    fontSize: '0.9rem',
    textAlign: 'center',
    fontWeight: 'bold',
    color: 'var(--color-text-pri)',
    width: '100%',
    marginTop: '-12px',
  },
  buttonLogin: {
    display: 'flex',
    justifyContent: 'space-between',
    p: 1.3,
    backgroundColor: '#f9f9f9',
    border: '1px solid #DAE2ED',
    color: 'text.primary',
    '&:hover': { backgroundColor: '#f0f0f0' },
  },
  buttonText: {
    fontSize: '0.94rem',
    fontWeight: 'bold',
    fontFamily: 'jost-light',
    width: '100%',
  },
  fixedImg: {
    position: 'absolute',
    zIndex: 1,
    top: '65%',
    left: '46%',
    transform: 'translate(-50%, -50%)',
    width: '98%',
  },
}
